<template>
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker v-model="inputDate" format="MM-DD-YYYY" :placeholder="['Start Date', 'End Date']" style="width: 100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-6">
                            <base-radio name="All" v-model="inputTenderType">All Tender Types</base-radio>
                            <base-radio name="Cash" v-model="inputTenderType">Cash Tender Type</base-radio>
                            <base-radio name="Non-Cash" v-model="inputTenderType">Non-Cash Tender Type</base-radio>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border: 0px; width: 20%" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border: 0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="'tender_totals_report'">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" class="float-right"  style=" width: 20%;" name="tender_totals_report.xls">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                birSalesReports: [],
                JsonData: [],
                inputTenderType: 'All'
            }
        },

        mounted: async function() {
            var component_x = this;

            var userId = secureStorage.getItem('userId');
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem('defaultSiteId');
            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null);
            if (site != undefined) {
                this.site_type = site.site_type
            }
            this.inputSite = [siteId]
        },

        computed: {
            ...mapState(['endPoint']),
        },

        components: {
            VueJsonToCsv
        },

        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },

            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },

            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },

            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },

            generateReport: async function() {
                if (this.inputDate.length == 0) {
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters.');
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                let from_header = this.inputDate[0].format('MMMM DD, YYYY hh:mm A')
                let to_header   = this.inputDate[1].format('MMMM DD, YYYY hh:mm A')

                var tenders = await HTTPRequest.getRequest(this.endPoint + 'tender_totals?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&tender_type=' + this.inputTenderType, null);

                if (tenders.length > 0) {
                    let doc = new jsPDF({orientation: 'landscape', unit: 'mm', format: 'legal'});

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = []
                    let header_detail = []

                    let total_amount = 0

                    header_detail.push(
                        { content: 'Date', styles: {halign: 'center'} },
                        { content: 'Tender Name', styles: {halign: 'center'}},
                        { content: 'Amount', styles: {halign: 'center'}}
                    )

                    headers = [header_detail]
                    let reportData = []

                    for (let i = 0; i < tenders.length; i++) {
                        let reportLine = tenders[i]

                        let reportDetail = []
                        reportDetail.push(
                            reportLine.BUSINESS_DATE,
                            reportLine.TENDER_NAME,
                            // reportLine.TENDER_AMOUNT
                            this.convertToCurrency(Number(reportLine.TENDER_AMOUNT))
                        )

                        reportData.push(Object.assign({}, reportDetail))

                        total_amount += Number(reportLine.TENDER_AMOUNT)
                    }

                    let total_details = ['', 'Total :', this.convertToCurrency(total_amount)]
                    reportData.push(Object.assign({}, ["rowLine"]));
                    reportData.push(Object.assign({}, total_details));

                    doc.setFontSize(14);
                    doc.setFontType("bold");
                    doc.text(15,20,"Tender Totals Report")
                    doc.setFontType("normal");
                    doc.setFontSize(10);

                    let site_text = ''
                    if (this.inputSite.length == 0) {
                        site_text = 'All Sites'
                    } else {
                        let sites = this.inputSite
                        for (var s = 0; s < sites.length; s++) {
                            if (s == 0) {
                                site_text += this.siteOptions.find(x => x.id === sites[s]).name
                            } else {
                                site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                            }
                        }
                    }

                    doc.text(340,20,site_text,"right");
                    doc.text(15,25,"From " + from_header + " to " + to_header)

                    let colStyles = {
                        0: {cellWidth: 100},
                        1: {cellWidth: 100},
                        2: {cellWidth: 100}
                    }

                    doc.autoTable({
                        startY: 35, 
                        head: headers, 
                        body: reportData, 
                        theme: 'plain',
                        tableWidth: 'wrap',
                        headStyles: {
                            lineWidth: 0.15,
                            cellPadding: 2
                        },
                        styles: {
                            cellPadding: 1.0, fontSize: 10, halign: 'right'
                        },
                        columnStyles: colStyles,
                        didParseCell: function(data) {
                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                data.cell.styles.fillColor = [0, 0, 0]
                                data.cell.styles.fontSize = 1
                                data.cell.styles.cellPadding = 0
                            } else if (data.row.section == 'body' && data.row.raw[0] == ''){ // checking if last line for total
                                data.cell.styles.fontStyle = 'bold'
                            }
                        }
                    });

                    let printed_by = secureStorage.getItem("email")
                    if (printed_by == null){
                        printed_by = ''
                    }

                    // doc.text(15,200,"Printed By: " + printed_by)
                    // doc.text(340,205,"Tender Totals Report", "right")
                    // doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))

                    let pageCount = doc.internal.getNumberOfPages();
                    let design_x = 340
                    let design_y =  205
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Tender Totals Report", design_x, design_y, i, pageCount)
                    }

                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters.');
                }
            },

            generateFile: async function() {
                 if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters.');
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                
                let from_header = this.inputDate[0].format('MMMM DD, YYYY hh:mm A')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY hh:mm A')

                var tenders = await HTTPRequest.getRequest(this.endPoint + 'tender_totals?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&tender_type=' + this.inputTenderType, null);
                if(tenders.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let header_detail = [];
                    let total_amount = 0

                    header_detail.push('Date','Tender Name', 'Amount',)
                    headers = header_detail
                    let reportData = []
                    for(let i=0; i < tenders.length; i++){
                        let reportLine = tenders[i]

                        
                        let detail = []
                        detail.push(
                            reportLine.BUSINESS_DATE,
                            reportLine.TENDER_NAME,
                            // reportLine.TENDER_AMOUNT
                            this.convertToCurrency(Number(reportLine.TENDER_AMOUNT))
                        )
                        reportData.push(Object.assign({}, detail))
                        total_amount += Number(reportLine.TENDER_AMOUNT)

                    }

                    let total_details = ['','Total :', this.convertToCurrency(total_amount)]
                    reportData.push(Object.assign({}, total_details));

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    reportData.push([])
                    reportData.push(["Tender Totals Report", "Generate By: " + printed_by,"From " + from_header + " to " + to_header])
                    reportData.push([])

                    let keys = headers;
                    let values = reportData;
                    var values_length = values.length;

                    let newJsonData = [];

                    for(var i = 0; i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                                }
                            )
                        )
                        );
                        newJsonData.push(result)
                    }

                    newJsonData.forEach(function(obj) {
                        for (var i in obj) {
                            if (obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                            }
                        }
                    });
                    site_specific.push(newJsonData)

                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                }
            },

            clearJsonData() {
                this.JsonData = [];
            },
        }
    };
</script>